import type { ReactElement } from 'react';
import { Alert, Drawer, Skeleton } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { EntityHistoryFeed } from '../../../components/entity-detail/EntityHistoryFeed.js';
import { useEntityActivities } from '../../activity/hooks/useEntityActivities.js';
import { describeActivity } from '../../activity/lib/describeActivity.js';

export function ContactAuditDrawer({
  contactId,
  open,
  onClose,
}: {
  contactId: string;
  open: boolean;
  onClose: () => void;
}): ReactElement {
  const { t } = useTranslation();
  const query = useEntityActivities('contact', open ? contactId : null);
  return (
    <Drawer
      title={t('crm.entity_detail.history')}
      open={open}
      onClose={onClose}
      size={460}
      destroyOnHidden
    >
      {query.isLoading ? (
        <Skeleton active />
      ) : query.error ? (
        <Alert type="error" title={t('crm.entity_detail.load_error')} />
      ) : (
        <EntityHistoryFeed
          items={(query.data ?? []).map((item) => ({
            id: item.id,
            date: item.occurredAt ?? item.createdAt,
            text: describeActivity(item),
          }))}
        />
      )}
    </Drawer>
  );
}
